import { WidgetType } from 'widgets/WidgetType';
import { WidgetTypeActionPayload } from 'widgets/store/actions';
import { StrategyParametersElement } from 'communication/types/strategyParams/StrategyParametersElement';
import {
    createClearStreamDataAction,
    createReceiveMessageAction,
    createWatchStreamAction,
    WidgetClearStreamDataAction,
    WidgetStreamMessageReceiveAction,
    WidgetWatchStreamAction,
    WidgetStreamMessageReceivePayload,
    WidgetStreamActionPayload,
} from 'widgets/store/stream/actions';

export type StrategyParametersMessageReceive =
    WidgetStreamMessageReceiveAction<StrategyParametersElement>;

export const receiveMessageAction =
    createReceiveMessageAction<StrategyParametersElement>(
        WidgetType.STRATEGY_PARAMETERS
    );

export const clearStrategyParemetersStreamData = createClearStreamDataAction(
    WidgetType.STRATEGY_PARAMETERS
);

export const watchStrategyParemetersStreamAction = createWatchStreamAction(
    WidgetType.STRATEGY_PARAMETERS
);

export type StrategyParametersStreamActionPayload =
    | WidgetTypeActionPayload
    | WidgetStreamActionPayload
    | WidgetStreamMessageReceivePayload<StrategyParametersElement>;

export type StrategyParametersStreamAction =
    | WidgetClearStreamDataAction
    | WidgetWatchStreamAction
    | StrategyParametersMessageReceive;
